import {
  Flex,
  FlexProps,
  TextSearchFilter as TextSearchFilterComponent,
  SearchIcon
} from '@blockanalitica/ui';
import styled, { css, useTheme } from 'styled-components';

const Container = styled(Flex)<FlexProps>`
  position: relative;
  align-items: center;
  padding: ${(props) =>
    `${props.theme.space['3xs']} ${props.theme.space['xs']} ${props.theme.space['3xs']}`};

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -401;
    mix-blend-mode: overlay;
    ${(props) => css`
      border-radius: ${props.theme.sizes['-2']};
      border: solid 1px ${props.theme.colors.white};
    `}
  }
`;

export default function TextSearchFilter({ filters, placeholder }) {
  const theme = useTheme();

  return (
    <Container>
      <SearchIcon size="0" color={theme.colors.muted} />
      <TextSearchFilterComponent
        placeholder={placeholder}
        {...filters}
        backgroundColor="transparent"
        border="none"
        fontSize="0"
      />
    </Container>
  );
}
